import React from 'react';
import Skeleton from 'ui/Skeleton';

const LoadingSkeleton = () => {
  return (
    <div>
      <div className="mb-12">
        <Skeleton height={30} width="100%" />
      </div>
      <div className="mb-12">
        <Skeleton height={30} width="100%" />
      </div>
      <div className="mb-20">
        <Skeleton height={30} width="100%" />
      </div>
    </div>
  );
};

export default LoadingSkeleton;
